import React from 'react'
import PropTypes from 'prop-types'
import {BoxIconWrap, BoxIconMarker, BoxIconInfo, BoxIconHeading, BoxIconTitle, BoxIconDesc} from './box-icon.style'
import { FaPhone, FaEnvelope, FaCheck, FaLifeRing, FaPaperPlane, FaInfoCircle, FaMapMarkerAlt } from 'react-icons/fa'

// Map font-awesome class names to react-icons components
const iconMap = {
    'fal fa-phone': FaPhone,
    'fa fa-phone': FaPhone,
    'fal fa-envelope': FaEnvelope,
    'fa fa-envelope': FaEnvelope,
    'fa fa-check': FaCheck,
    'fal fa-check': FaCheck,
    'fal fa-life-ring': FaLifeRing,
    'fal fa-paper-plane': FaPaperPlane,
    'fal fa-info-circle': FaInfoCircle,
    'fa fa-map-marker-alt': FaMapMarkerAlt,
}

const BoxIcon = ({icon, title, desc, heading, ...restProps}) => {
    const {wrapperStyle, iconStyle, infoStyle, titleStyle, descStyle, headingStyle} = restProps;
    const IconComponent = iconMap[icon]

    return(
        <BoxIconWrap {...wrapperStyle}>
            {icon && (
                <BoxIconMarker {...iconStyle}>
                    {IconComponent ? <IconComponent /> : null}
                </BoxIconMarker>
            )}
            {(title || desc) && (
                <BoxIconInfo {...infoStyle}>
                    {heading && <BoxIconHeading {...headingStyle}>{heading}</BoxIconHeading>}
                    {title && <BoxIconTitle {...titleStyle}>{title}</BoxIconTitle>}
                    {desc && <BoxIconDesc {...descStyle}>{desc}</BoxIconDesc>}
                </BoxIconInfo>
            )}
        </BoxIconWrap>
    )
}

BoxIcon.propTypes = {
    wrapperStyle: PropTypes.object,
    iconStyle: PropTypes.object,
    infoStyle: PropTypes.object,
    titleStyle: PropTypes.object,
    descStyle: PropTypes.object,
    headingStyle: PropTypes.object
}


export default BoxIcon;